import { TriangleAlert } from 'lucide-react';
import type * as React from 'react';
import { ConfirmDialog } from '@verclam/ui-kit';

type Props = {
	readonly visible: boolean;
	readonly onAccept: () => void;
	readonly onHide: () => void;
};

/** Warns that a list gesture on a verified document sends it back to « En cours de vérification ». */
const ConfirmVerifiedDocumentEditDialog: React.FC<Props> = ({ visible, onAccept, onHide }) => {
	return (
		<ConfirmDialog
			visible={visible}
			onHide={onHide}
			header="Modifier ce document vérifié ?"
			icon={<TriangleAlert size={24} aria-hidden="true" />}
			message="Ce geste repassera le document en cours de vérification."
			acceptLabel="Continuer"
			rejectLabel="Annuler"
			accept={onAccept}
			reject={onHide}
		/>
	);
};

export default ConfirmVerifiedDocumentEditDialog;
